export const ACCENT = "a";
export const FLAM = "f";
export const DIDDLE = "d";
export const CHEESE = "c";
export const BUZZ = "b";
export const LEFT_STICKING = "l";
export const RIGHT_STICKING = "r";
// Articulations, marked on a note like its ornaments.
export const STACCATO = "s";
export const TENUTO = "t";
export const MARCATO = "m";
export const FERMATA = "u";
export const DOWN_BOW = "n";
export const UP_BOW = "v";
export const OPEN = "o";
export const STOPPED = "p";
